<template>
  <v-dialog v-model="orderInvoicingModalVisible" max-width="1200px" min-height="600px" >
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">Laskuta tilaus {{orderInvoicingModalEnv === 'development' ? 'DEV' :''}}</span>
      </v-card-title>
      <!-- <v-row class="mt-1 pr-2" no-gutters style="font-size:12px;border-bottom:1px dotted #ccc;font-weight:600;width:100%;" >
        <v-col cols="6" class="px-0 py-0">
          <v-row no-gutters wrap class="px-0 mx-0">
            <v-col cols="1" class="py-1 pl-2">
              <span class="pl-2" >
              </span>
            </v-col>
            <v-col cols="11" class="py-1 pl-2">Nimi</v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="px-0 py-0">
        </v-col>
      </v-row> -->
      <div style="overflow-y:scroll;width:100%;border-bottom:1px solid #ccc;" class="orange-scrollbar" v-if="orderInvoicingModalOrderId && orders[orderInvoicingModalOrderId]">
        <v-row wrap no-gutters class="mb-0 mt-0"  style="width:100%;min-height:800px;">
          <v-col cols="2" class="px-0 py-0" style="border-right:1px solid #ccc;border-top:1px solid #ccc;">
            <div :style="selectedInvoice === '' ? 'background:#F8693B;color:#FFF;border-bottom:1px solid #ccc;' : 'background:#EEE;border-bottom:1px solid #ccc;'" class="text-center pointer" @click="selectedInvoiceData = {};selectedItemsForInvoice = [];selectedInvoice = ''">Laskuttamattomat</div>
            <div v-if="invoices && Object.keys(invoices).length > 0">
              <div :style="selectedInvoice === iKey ? 'background:#F8693B;color:#FFF;border-left:1px solid #ccc;border-bottom:1px solid #ccc;' : 'background:#EEE;border-left:1px solid #ccc;border-bottom:1px solid #ccc;'" 
                @click="selectedInvoiceData = {};selectedItemsForInvoice = [];selectedInvoice = iKey" 
                v-for="(iKey) in Object.keys(invoices)" 
                :key="iKey+'_invoice'" 
                class="text-center pointer">
                Lasku #{{invoices[iKey].invoiceNumber}} <span style="font-size:12px;">({{invoices[iKey].invoiceDate ? customFormatter(invoices[iKey].invoiceDate) : ''}})</span>
              </div>
            </div>
          </v-col>
          <v-col cols="5" class="px-0 py-0" style="border-right:1px solid #ccc;">
            <div v-if="!isOkToInvoiceViaPlatform">
              <v-row no-gutters wrap class="py-4 px-0 mx-0 text-center" style="border-top:1px solid #ccc;" >
                <div class="text-center" style="width:100%;font-weight:600;"><span style="background:black;color:#FFF;padding:3px;">Tilaukselle on tehty jo laskuja myyntitilauksen kautta. Suorita laskutus Netvisorissa.</span></div>
              </v-row>
            </div>
            
            
            
            <!-- MYYNTI TILAUS -->
            <div v-if="orderInvoicingModalEnv === 'production' && orders[orderInvoicingModalOrderId].netvisorKey" class="pt-0 px-0 mx-0" style="border-top:1px solid #ccc;" >
              <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:120px;" class="pl-2">Myyntilaus #:</span>
              <span v-if="orders[orderInvoicingModalOrderId].netvisorKey" style="font-size:12px;padding-top:1px;" class="pl-2">
                <span class="pr-2">{{orders[orderInvoicingModalOrderId].netvisorId}}</span>
                <a :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/order.aspx?id='+orders[orderInvoicingModalOrderId].netvisorKey" target="_blank">
                  <i style="color:blue;font-size:10px;" class="fas fa-external-link-alt" />
                </a>
                <button class="avecor-button-global small-add-button ml-5" @click="$store.dispatch('deleteOrderOrInvoiceNetvisor', {env:'production',invoiceType:'order',orderId:orderInvoicingModalOrderId,netvisorKey:orders[orderInvoicingModalOrderId].netvisorKey})" style="padding-bottom:10px !important;">POISTA MYYNTITILAUS</button>
              </span>
            </div>
            <div v-if="orderInvoicingModalEnv === 'development' && orders[orderInvoicingModalOrderId].netvisorKey_test_env" class="pt-0 px-0 mx-0" style="border-top:1px solid #ccc;" >
              <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:120px;" class="pl-2">Myyntilaus # (test):</span>
              <span v-if="orders[orderInvoicingModalOrderId].netvisorKey_test_env" style="font-size:12px;padding-top:1px;" class="pl-2">
                <span class="pr-2">{{orders[orderInvoicingModalOrderId].netvisorId_test_env}}</span>
                <a :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/order.aspx?id='+orders[orderInvoicingModalOrderId].netvisorKey_test_env" target="_blank">
                  <i style="color:blue;font-size:10px;" class="fas fa-external-link-alt" />
                </a>
                <button class="avecor-button-global small-add-button ml-5" @click="$store.dispatch('deleteOrderOrInvoiceNetvisor', {env:'development',invoiceType:'order',orderId:orderInvoicingModalOrderId,netvisorKey:orders[orderInvoicingModalOrderId].netvisorKey_test_env})" style="padding-bottom:10px !important;">POISTA MYYNTITILAUS</button>
              </span>
            </div>
            <div>
            <!-- LASKUN TIEDOT -->
              <div v-if="selectedInvoice !== ''" class="pt-0 px-0 mx-0" style="border-top:1px solid #ccc;" >
                <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:100px;" class="pl-2">Laskun status:</span>
                <span v-if="selectedInvoiceData && selectedInvoiceData.status" style="font-size:12px;padding-top:1px;" class="pl-2">{{selectedInvoiceData.status["_"]}} {{isInvoiceUpdateEnabled ? '(laskun päivitys ok)' : ''}}</span>
              </div>
              <div v-if="selectedInvoice !== ''" class="pt-0 px-0 mx-0" style="border-top:1px solid #ccc;" >
                <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:100px;" class="pl-2">Laskun #:</span>
                <span v-if="invoices[selectedInvoice]" style="font-size:12px;padding-top:1px;" class="pl-2">
                  <span class="pr-2">{{invoices[selectedInvoice].invoiceNumber}}</span>
                  <a v-if="orderInvoicingModalEnv === 'production'" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+selectedInvoice" target="_blank">
                    <i style="color:blue;font-size:10px;" class="fas fa-external-link-alt" />
                  </a>
                  
                  <span v-if="orderInvoicingModalEnv === 'development'">
                    <a :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+selectedInvoice" target="_blank">
                      <i style="color:blue;font-size:10px;" class="fas fa-external-link-alt" />
                    </a>
                    <!-- <button class="avecor-button-global small-add-button ml-5" @click="deleteInvoice()" style="padding-bottom:10px !important;">POISTA LASKU</button> -->
                  </span>
                  <button class="avecor-button-global small-add-button ml-5" @click="deleteInvoice()" style="padding-bottom:10px !important;">POISTA LASKU</button>
                </span>
              </div>
              <!-- LASKUN PÄIVÄ -->
              <div :class="selectedInvoice === '' ? 'py-1' : 'py-1 pl-0'" style="border-top:1px solid #ccc;" >
                <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:130px;" class="pl-2">Laskun päivä:</span>
                <v-menu
                  :nudge-right="0"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      :value="customFormatter(selectedDateForInvoice)"
                      readonly
                      class="avecor-select hide-field-details minimize-height ml-2 pl-2 pt-0 mt-0 order-expand-header-field-value"
                      hide-details
                      dense
                      :disabled="selectedInvoice !== '' && !isInvoiceUpdateEnabled"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => selectedDateForInvoice = v" :value="customFormatter(selectedDateForInvoice)" locale="fi-fi"></v-date-picker>
                </v-menu>
              </div>
              <div :class="selectedInvoice === '' ? 'py-1' : 'py-1 pl-0'" style="border-top:1px solid #ccc;" >
                <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:130px;" class="pl-2">Laskun kirjauspäivä:</span>
                <v-menu
                  :nudge-right="0"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      :value="customFormatter(selectedDateForInvoiceEntry)"
                      readonly
                      class="avecor-select hide-field-details minimize-height ml-2 pl-2 pt-0 mt-0 order-expand-header-field-value"
                      hide-details
                      dense
                      :disabled="selectedInvoice !== '' && !isInvoiceUpdateEnabled"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => selectedDateForInvoiceEntry = v" :value="customFormatter(selectedDateForInvoiceEntry)" locale="fi-fi"></v-date-picker>
                </v-menu>
              </div>
              <!-- YRITYS TIEDOT -->
              <v-row no-gutters>
                <div class="text-left pl-2" style="background:#eeee;border-top:1px solid #ccc;font-size:13px;width:100%;">YRITYS</div>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Yritys:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.companyName}}</span>
                  </div>
                </v-col>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Y-tunnus:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.companyId}}</span>
                  </div>
                </v-col>
                <v-col cols="12" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Osoite:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.deliveryAddress + ', ' + orderCompany.deliveryPostalCode + ' ' + orderCompany.deliveryCity}}</span>
                  </div>
                </v-col>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Lask. formaatti:</span>
                    <span v-if="settings.billingFormats[orderCompany.billingFormat]" style="font-size:12px;padding-top:1px;" class="pl-1">{{settings.billingFormats[orderCompany.billingFormat].fi}}</span>
                    <span v-else style="color:red;font-size:12px;padding-top:1px;" class="pl-1">Formaatti puuttuu</span>
                  </div>
                </v-col>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Maksuehto:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.paymentTermNetvisor}}</span>
                  </div>
                </v-col>  
                <v-col cols="6" style="border-top:1px solid #ccc;" v-if="orderCompany.billingFormat === 'eInvoice'">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Operaattori:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{getBillingOperatorName}}</span>
                  </div>
                </v-col>
                <v-col cols="6" style="border-top:1px solid #ccc;" v-if="orderCompany.billingFormat === 'eInvoice'">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Verk. laskuosoite:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.eBillingAddress}}</span>
                  </div>
                </v-col>
                <v-col cols="12" style="border-top:1px solid #ccc;" v-if="orderCompany.billingFormat === 'paper'">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Laskutusosoite:</span>
                    <span v-if="orderCompany.differentBillingAddress" style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.billingAddress + ', ' + orderCompany.billingPostalCode + ' ' + orderCompany.billingCity}}</span>
                    <span v-else style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.deliveryAddress + ', ' + orderCompany.deliveryPostalCode + ' ' + orderCompany.deliveryCity}}</span>
                  </div>
                </v-col>
                <v-col cols="12" style="border-top:1px solid #ccc;" v-if="orderCompany.billingFormat === 'email'">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">Laskutus @:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderCompany.billingEmail}}</span>
                    <!-- <span v-else style="font-size:12px;padding-top:1px;" class="pl-1">{{orderContact.email}}</span> -->
                  </div>
                </v-col>
              </v-row>
              <!-- KONTAKTIN TIEDOT -->
              <v-row no-gutters>
                <div class="text-left pl-2" style="background:#eeee;border-top:1px solid #ccc;font-size:13px;width:100%;">KONTAKTI</div>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;width:40px;" class="pl-2">Nimi:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderContact.firstName + ' ' + orderContact.lastName}}</span>
                  </div>
                </v-col>
                <v-col cols="6" style="border-top:1px solid #ccc;">
                  <div>
                    <span style="font-size:12px;padding-top:1px;font-weight:600;display:inline-block;" class="pl-2">@:</span>
                    <span style="font-size:12px;padding-top:1px;" class="pl-1">{{orderContact.email}}</span>
                  </div>
                </v-col>
              </v-row>
              
              <div v-if="!isOkToInvoiceViaPlatform">
                
              </div>
              <div v-else-if="getLineItems.length == 0 && !showDeliveryChargeItem">
                <v-row no-gutters wrap class="pt-4 px-0 mx-0 text-center" style="border-top:1px solid #ccc;" >
                  <div class="text-center" style="width:100%;font-weight:600;">Ei laskutettavaa. </div>
                </v-row>
              </div>
              <!-- LINE ITEMS -->
              <div v-else>
                <div class="text-left pl-2" style="background:#eeee;border-top:1px solid #ccc;font-size:13px;">TUOTTEET</div>
                <v-row no-gutters wrap class="px-0 mx-0" v-for="(li,i) in getLineItems" :key="li.rowId+'_invoice'" :style="i === 0 || (getLineItems[i-1] && getLineItems[i].opId !== getLineItems[i-1].opId) ? 'border-top:1px solid #ccc;padding-top:3px;' : ''" >
                  <v-col cols="1" v-if="selectedInvoice === ''" class="py-0 pl-2" style="line-height:14px;">
                    <div class="pl-2 pt-1" style="display:inline-block;" >
                      <input v-if="i === 0 || (getLineItems[i-1] && getLineItems[i].opId !== getLineItems[i-1].opId)" style="" type="checkbox" :checked="selectedItemsForInvoice.includes(li.rowId)" @click="selectOpItemsForInvoice(li.rowId,li.opId)"/> 
                    </div>
                  </v-col>
                  <v-col :cols="selectedInvoice === '' ? 11 : 12" class="pb-0 pl-0">
                    <div v-if="i === 0 || (getLineItems[i-1] && getLineItems[i].opId !== getLineItems[i-1].opId)" style="font-size:12px;padding-top:1px;font-weight:600;" class="pl-2">
                      <div>{{li.productName}} <span v-if="li.partial" style="background:#E65100;color:#fff;" class="px-1"> (Osa-toimitus)</span></div>
                      <div style="font-style:italic;font-weight:400">Tuotekoodi: {{li.avecorSku}} </div>
                      <div v-if="li.productsShippedDate" style="font-weight:400;"><span style="font-style:italic;">Toimitus pvm tuotteella: {{customFormatter(li.productsShippedDate)}}</span> </div>
                      <div v-else style="font-weight:400;"><span style="font-style:italic;">Toimitus pvm tuotteella: ei vielä toimitettu</span> </div>
                      <div v-if="li.whenToInvoice && li.whenToInvoiceSetManually" style="font-weight:400;"><span style="background:#64B5F6;padding:2px 4px;">Laskutus pvm tuotteella: {{customFormatter(li.whenToInvoice)}}</span> </div>

                    </div>
                    <div class="pl-8" style="line-height:14px;">
                      <div style="display:inline-block;width:30%;font-weight:600;font-size:11px;">{{li.rowName }}</div>
                      <div style="display:inline-block;width:10%;font-size:11px;">{{li.quantity}}</div>
                      <div style="display:inline-block;width:10%;font-size:11px;">{{li.unitPrice}}€</div>
                      <div style="display:inline-block;width:27%;font-size:11px;">{{li.priceOut}}€</div>
                    </div>
                  </v-col>
                </v-row>
                <!-- DELIVERY CHARGE -->
                <v-row no-gutters wrap class="mt-1 px-0 mx-0" style="border-top:1px solid #ccc;padding-top:3px;" v-if="showDeliveryChargeItem">
                  <v-col cols="1" v-if="selectedInvoice === ''" class="py-0 pl-2">
                    <span class="pl-2" >
                      <input style="" type="checkbox" :checked="selectedItemsForInvoice.includes('deliveryCharge')" @click="selectedItemsForInvoice.includes('deliveryCharge') ? selectedItemsForInvoice = selectedItemsForInvoice.filter(i => {return i !== 'deliveryCharge'}) : selectedItemsForInvoice.push('deliveryCharge')"/> 
                      </span>
                    </v-col>
                  <v-col :cols="selectedInvoice === '' ? 11 : 12" class="py-0 pl-2">
                    <!-- <div style="font-size:12px;padding-top:2px">Toimitus</div> -->
                    <div style="font-size:12px;">
                      <div style="display:inline-block;width:30%;font-weight:600;font-size:12px;">Toimitus</div>
                      <div style="display:inline-block;width:10%;font-size:11px;"></div>
                      <div style="display:inline-block;width:10%;font-size:11px;"></div>
                      <div style="display:inline-block;width:27%;font-size:11px;" class="pl-4">{{orders[orderInvoicingModalOrderId] ? orders[orderInvoicingModalOrderId].deliveryCharge : 0}}€</div>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters wrap class="px-0 mx-0 mt-1" style="border-top:1px solid #ccc;border-bottom:1px solid #ccc;background:#fff" >
                  <v-col cols="12" class="pt-1 pb-1 pl-2">
                    <div style="font-size:12px;padding-top:2px" class="text-right">
                      <div style="display:inline-block;font-weight:600;font-size:12px;">YHTEENSÄ <span class="pl-4">{{getTotalOut()}}€</span></div>
                      
                      <div style="display:inline-block;font-size:11px;" class="pl-4"></div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
          <v-col cols="5" class="px-0 py-0 text-center my-0" style="border-top:1px solid #ccc;">
            <div v-if="selectedInvoice === ''" class="py-4">PDF preview (valitse ensin lasku)</div>
            <div v-else style="height:100%;">
              <iframe style="width:100%;height:99%" id="pdfPreviewInvoice" ref="pdfPreviewInvoice" type="application/pdf"></iframe>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-card-actions>
        <div v-if="selectedInvoice === ''" style="display:flex;font-size:12px;">
          Laskun numero <input v-model="manual_invoiceNumber" style="background:#ddd;width:75px;" class="mx-2 px-1">
          Laskun id <input v-model="manual_invoiceId" style="background:#ddd;width:75px;" class="mx-2 px-1">
        </div>
        <v-btn v-if="selectedInvoice === ''" :disabled="netvisorSyncActive || selectedItemsForInvoice.length == 0 || !manual_invoiceNumber || !manual_invoiceId" class="avecor-button-global add-button mb-2 mt-2" text @click="createInvoiceToNetvisor(true)" >Lisää lasku</v-btn>
        <v-spacer></v-spacer>
        
        <v-btn class="avecor-button-global add-button mb-2 mt-2" text @click="close">Peruuta</v-btn>
        
        <v-btn v-if="selectedInvoice === ''" :disabled="netvisorSyncActive || selectedItemsForInvoice.length == 0" class="avecor-button-global add-button mb-2 mt-2" text @click="createInvoiceToNetvisor(false)" >Luo lasku</v-btn>
        <v-btn v-else-if="isInvoiceUpdateEnabled" :disabled="netvisorSyncActive" class="avecor-button-global add-button mb-2 mt-2" text @click="updateInvoiceToNetvisor()" >Päivitä lasku</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import shared from './../../shared'
import axios from 'axios'
import firebase from 'firebase'

export default {
    props:[],
    created () {
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.createVariationNameDataIncluded = shared.createVariationNameDataIncluded
      this.createVariationAvecorSkuDataIncluded = shared.createVariationAvecorSkuDataIncluded
      this.formatToThreeDecimals = shared.formatToThreeDecimals
      this.syncOrderToNetvisor = shared.syncOrderToNetvisor
      this.logToOrderHistory = shared.logToOrderHistory
    },
    data: () => ({
      manual_invoiceNumber:'',
      manual_invoiceId:'',
      netvisorSyncActive:false,
      pdfPreview:null,
      selectedDateForInvoice:'',
      selectedDateForInvoiceEntry:'',
      selectedInvoice:'',
      selectedInvoiceData:{},
      selectedItemsForInvoice:[],
      editedIndex: -1,
    }),
    watch: {
      selectedInvoice:{
        handler(newInvoiceKey, oldInvoiceKey) {
          if(newInvoiceKey !== oldInvoiceKey) {
            this.manual_invoiceId = ''
            this.manual_invoiceNumber = ''
            if(newInvoiceKey === '') {
              this.pdfPreview = null
              var today = new Date()
              today.setDate(today.getDate() + 1)
              today = today.toISOString().split('T')[0]
              console.log(today)
              this.selectedDateForInvoice = today
              this.selectedDateForInvoiceEntry = today
            }
            else {
              this.selectedDateForInvoice = this.invoices[newInvoiceKey].invoiceDate
              this.selectedDateForInvoiceEntry = this.invoices[newInvoiceKey].invoiceDateEntry ? this.invoices[newInvoiceKey].invoiceDateEntry : ''
              console.log(this.invoices[newInvoiceKey])
              
              this.fetchAndSetPDFPreviewForInvoice()
            } 
          }
    
        }
      },
      orderInvoicingModalVisible:{
        handler(visible) {
          if(!visible) {
            this.selectedInvoice = ''
            this.selectedInvoiceData = {}
            this.selectedItemsForInvoice = []
          }
        }
      },
    },
    mounted() {
      var today = new Date()
      today.setDate(today.getDate() + 1)
      today = today.toISOString().split('T')[0]
      console.log(today)
      this.selectedInvoice = ''
      this.selectedDateForInvoice = today
      this.selectedDateForInvoiceEntry = today
    },
    computed: {
      getBillingOperatorName(){
        var name = ""
        var matched = this.settings.eBillingOperators.filter(oper => oper.id === this.orderCompany.eBillingOperator)
        if(matched && matched[0]) name = matched[0].name
        return name
      },
      orderCompany(){
        var company = {}
        company = this.companies[this.orders[this.orderInvoicingModalOrderId].companyId]
        return company
      },
      orderContact(){
        var contact = {}
        contact = this.contacts[this.orders[this.orderInvoicingModalOrderId].contactId]
        return contact
      },
      isOkToInvoiceViaPlatform(){
        var isOkToInvoiceViaPlatform = true
        if(this.invoices && Object.keys(this.invoices).length > 0){
          Object.keys(this.invoices).forEach(iKey => {
            var i = this.invoices[iKey]
            if(!i.invoiceNumber) return
            if(!i.selectedItemsForInvoice) isOkToInvoiceViaPlatform = false
          })
          
        }
        return isOkToInvoiceViaPlatform
      },
      isInvoiceUpdateEnabled(){
        if(this.selected !== '' && this.selectedInvoiceData && this.selectedInvoiceData.status && this.selectedInvoiceData.status['$'] && this.selectedInvoiceData.status['$'].status === 'unsent') return true
        return false
      },
      invoices(){
        var invoices = null
        var oId = this.orderInvoicingModalOrderId
        var o = this.orders[oId]
        if(this.orderInvoicingModalEnv === 'development' && o.invoicesTest){
          invoices = o.invoicesTest
        }
        else if(this.orderInvoicingModalEnv === 'production' && o.invoices){
          invoices = o.invoices
        }
        var invoicesToReturn = {}
        if(invoices){
          Object.keys(invoices).forEach(iKey => {
            if(invoices[iKey].invoiceNumber) invoicesToReturn[iKey] = invoices[iKey]
          })
        }
        return invoicesToReturn
      },
      showDeliveryChargeItem(){
        var show = null
        var oId = this.orderInvoicingModalOrderId
        var o = this.orders[oId]
        if(this.selectedInvoice === ""){
          show = true
          if(this.invoices){
            Object.keys(this.invoices).forEach(iKey => {
              this.invoices[iKey].selectedItemsForInvoice && this.invoices[iKey].selectedItemsForInvoice.includes('deliveryCharge') ? show = false : ''
            })
          }
        }
        else {
          show = false
          if(this.invoices[this.selectedInvoice] && this.invoices[this.selectedInvoice].selectedItemsForInvoice) this.invoices[this.selectedInvoice].selectedItemsForInvoice.includes('deliveryCharge') ? show = true : ''
        }      
        return show
      },
      getLineItems(){
        var oId = this.orderInvoicingModalOrderId
        var productVariations = this.productVariations
        var products = this.products
        var orderedProducts = this.orderedProducts
        var o = this.orders[oId]
        var lineItemsForOrder = []

        if(!this.isOkToInvoiceViaPlatform) return lineItemsForOrder

        try{
          Object.keys(orderedProducts).forEach(opId => {
            var op = orderedProducts[opId]
            if(oId === op.orderId){
              var productUnitPrice = this.formatToThreeDecimals(op.unitPrice)
              var whenToInvoice = op.whenToInvoice ? op.whenToInvoice : ''
              var whenToInvoiceSetManually = op.whenToInvoiceSetManually ? true :false
              var printUnitPrice = this.formatToThreeDecimals(op.unitPrintPrice)
              var positioningUnitPrice = this.formatToThreeDecimals(op.pricePerPositioning)
              var p = products[op.productId]
              var pv = productVariations[op.productVariationId]
              var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
              var avecorSku = this.createVariationAvecorSku(pv.id)

              if(op.partialDeliveries && Object.keys(op.partialDeliveries).length > 0){

                Object.keys(op.partialDeliveries).forEach(pdId => {
                  var pd = op.partialDeliveries[pdId]
                  var productsShippedDate = pd.date
                  var productQuantity = Number(pd.deliveredAmount)
                  var printQuantity = Number(pd.deliveredAmount)
                  
                  var productOut = this.formatToThreeDecimals(productQuantity * productUnitPrice)
                  var printOut = this.formatToThreeDecimals(printQuantity * printUnitPrice)
                  
                  var idProduct = 'pd__' + opId + '__' + pdId + '__product' 
                  lineItemsForOrder.push({ id:pdId,rowId:idProduct,rowType:'product',opId,partial:true,rowName:'Tuote',opId,productsShippedDate,whenToInvoice,whenToInvoiceSetManually,productName,avecorSku,priceOut:productOut,quantity:productQuantity,unitPrice:productUnitPrice})

                  if(op.print){
                    var idPrint = 'pd__' +opId + '__' + pdId + '__print' 
                    lineItemsForOrder.push({ id:pdId,rowId:idPrint,rowType:'print',opId,partial:true,rowName:'Merkkaus',productsShippedDate,productName,avecorSku,priceOut:printOut,quantity:printQuantity,unitPrice:printUnitPrice})
                  }
                })
                if(op.print){
                  var idPositioning = 'op__' + opId + '__all__positioning' 
                  var numberOfPositionings = Number(op.numberOfPositionings)
                  var positioningOut = this.formatToThreeDecimals(numberOfPositionings * positioningUnitPrice)
                  lineItemsForOrder.push({ id:opId,rowId:idPositioning,rowType:'positioning',opId,partial:true,rowName:'Asemointi',productsShippedDate,productName,avecorSku,priceOut:positioningOut,quantity:numberOfPositionings,unitPrice:positioningUnitPrice})
                }
              }
              else {
                if(op.orderInvoiceStatus === 'doNotInvoice') return
                
                var productQuantity = Number(op.quantity)
                var printQuantity = Number(op.printQuantity)
                var numberOfPositionings = Number(op.numberOfPositionings)
                var productsShippedDate = op.shippedDate ? op.shippedDate : ''
                var productOut = this.formatToThreeDecimals(productQuantity * productUnitPrice)
                var printOut = this.formatToThreeDecimals(printQuantity * printUnitPrice)
                var positioningOut = this.formatToThreeDecimals(numberOfPositionings * positioningUnitPrice)

                var idProduct = 'op__' + opId + '__all__product' 
                lineItemsForOrder.push({ id:opId,rowId:idProduct,rowType:'product',opId,partial:false,rowName:'Tuote',opId,productsShippedDate,whenToInvoice,whenToInvoiceSetManually,productName,avecorSku,priceOut:productOut,quantity:productQuantity,unitPrice:productUnitPrice})
                
                
                if(op.print){
                  var idPrint = 'op__' + opId + '__all__print'
                  var idPositioning = 'op__' + opId + '__all__positioning'
                  lineItemsForOrder.push({ id:opId,rowId:idPrint,rowType:'print',opId,partial:false,rowName:'Merkkaus',productsShippedDate,productName,avecorSku,priceOut:printOut,quantity:printQuantity,unitPrice:printUnitPrice})
                  lineItemsForOrder.push({ id:opId,rowId:idPositioning,rowType:'positioning',opId,partial:false,rowName:'Asemointi',productsShippedDate,productName,avecorSku,priceOut:positioningOut,quantity:numberOfPositionings,unitPrice:positioningUnitPrice})
                }
              }
            }
          })

          var selectedInvoiceItems = []
          var allInvoicedItems = []
          if(this.selectedInvoice === ""){
            if(this.invoices){
              Object.keys(this.invoices).forEach(iKey => {
                allInvoicedItems = [...allInvoicedItems, ...this.invoices[iKey].selectedItemsForInvoice]
              })
            }
          }
          else {
            if(this.invoices[this.selectedInvoice]) selectedInvoiceItems = this.invoices[this.selectedInvoice].selectedItemsForInvoice
          }  

          // FILTER
          var lineItemsVisible = []
          lineItemsForOrder.forEach(li => {
            if(this.selectedInvoice === ""){
              if(!allInvoicedItems.includes(li.rowId)) lineItemsVisible.push(li)
            }
            else {
              if(selectedInvoiceItems.includes(li.rowId)) lineItemsVisible.push(li)
            }
          })

          return lineItemsVisible
        }
        catch(e){
          console.log(e)
        }

        return lineItemsForOrder
      },
      ...mapFields({
        staff:'staff.staff',
        settings:'settings',
        user:'user',
        orderInvoicingModalVisible:"modals.orders.invoicing.visible",
        orderInvoicingModalOrderId:"modals.orders.invoicing.orderId",
        orderInvoicingModalEnv:"modals.orders.invoicing.env",
        products:"product.products",
        productVariations:"productVariation.productVariations",
        orders:"order.orders",
        orderedProducts:"orderedProduct.orderedProducts",
        companies:"company.companies",
        contacts:"contact.contacts"
      }),
    },
    methods: {
      timer(ms) { return new Promise(res => setTimeout(res, ms)); },
      async deleteInvoice(){
        
        this.$store.dispatch('deleteOrderOrInvoiceNetvisor', {env:this.orderInvoicingModalEnv,invoiceType:'invoice',orderId:this.orderInvoicingModalOrderId,netvisorKey:this.selectedInvoice})
        this.selectedInvoice = ''
      },
      selectOpItemsForInvoice(rowId,opId){
        var isIncluded = this.selectedItemsForInvoice.includes(rowId) ? true :false

        if(isIncluded){

          this.selectedItemsForInvoice = this.selectedItemsForInvoice.filter(i => !i.includes(opId)) 
        }
        else {
          this.getLineItems.forEach(li => {
            if(li.opId === opId && !this.selectedItemsForInvoice.includes(li.rowId)) this.selectedItemsForInvoice.push(li.rowId)
          })
        }
      },
      getTotalOut(){
        var total = 0
        var selectedItemsForInvoice = this.selectedItemsForInvoice
        if(this.selectedInvoice !== '' && this.invoices[this.selectedInvoice].selectedItemsForInvoice) selectedItemsForInvoice = JSON.parse(JSON.stringify(this.invoices[this.selectedInvoice].selectedItemsForInvoice))
        this.getLineItems.forEach(li => {
          if(this.selectedInvoice === '' && this.selectedItemsForInvoice.includes(li.rowId)) total += li.priceOut
          else if(this.selectedInvoice !== '') total += li.priceOut
        })
        if(this.showDeliveryChargeItem && selectedItemsForInvoice.includes('deliveryCharge')) total += this.formatToThreeDecimals(this.orders[this.orderInvoicingModalOrderId].deliveryCharge)
        return total
      },
      async fetchAndSetPDFPreviewForInvoice(){
        var invoiceNetvisorKey = this.selectedInvoice
        var salespersonId = this.orders[this.orderInvoicingModalOrderId].salesperson

        var isLogogear = this.staff[salespersonId].isLogogear ? true : false
        var env = this.orderInvoicingModalEnv
        //var env = "development"
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Noudetaan laskun pdf...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/logogear-erp/us-central1/getNetvisorInvoicePDFFunction': 'https://us-central1-logogear-erp.cloudfunctions.net/getNetvisorInvoicePDFFunction'
          let res = await axios.post(url,
            { invoiceNetvisorKey, env, isLogogear },
          );
          this.selectedInvoiceData = {status:res.data.status}
          this.$refs['pdfPreviewInvoice'].src = ""
          this.$refs['pdfPreviewInvoice'] ? this.$refs['pdfPreviewInvoice'].src = 'data:application/pdf;base64,'+res.data.pdf : ''
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"PDF päivitetty.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      async updateInvoiceToNetvisor(){
        try{
          this.netvisorSyncActive = true
          var oId = this.orderInvoicingModalOrderId
          var o = this.orders[oId]
          var env = this.orderInvoicingModalEnv
          var selectedItemsForInvoice = JSON.parse(JSON.stringify(this.invoices[this.selectedInvoice].selectedItemsForInvoice))
          

          var selectedItemsObject = {}
          this.getLineItems.forEach(li => {
            if(selectedItemsForInvoice.includes(li.rowId)) selectedItemsObject[li.rowId] = li
          })


          var selectedDateForInvoice = this.selectedDateForInvoice
          var selectedDateForInvoiceEntry = this.selectedDateForInvoiceEntry
          if(this.selectedDateForInvoice && !this.selectedDateForInvoice.seconds) selectedDateForInvoice = firebase.firestore.Timestamp.fromDate(new Date(this.selectedDateForInvoice));
          if(this.selectedDateForInvoiceEntry && !this.selectedDateForInvoiceEntry.seconds) selectedDateForInvoiceEntry = firebase.firestore.Timestamp.fromDate(new Date(this.selectedDateForInvoiceEntry));

          var invoiceObject = {
            selectedItemsForInvoice,
            selectedInvoice:this.selectedInvoice,
            selectedItemsObject,
            selectedDateForInvoice:selectedDateForInvoice,
            selectedDateForInvoiceEntry:selectedDateForInvoiceEntry
          }
          if(selectedItemsForInvoice.length == 0){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:'Valitse rivejä laskulle.', snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            return
          }
          console.log(invoiceObject)
        
          await this.syncOrderToNetvisor(this.orderInvoicingModalOrderId,env, 'invoice', invoiceObject)
          this.fetchAndSetPDFPreviewForInvoice()
          this.netvisorSyncActive = false
        }
        catch(e){
          console.log(e)
          
          this.netvisorSyncActive = false
        }


        
        
      },
      async createInvoiceToNetvisor(isManual){
        try{
          this.netvisorSyncActive = true
          console.log(this.selectedItemsForInvoice)
          var selectedItemsForInvoice = []
          var env = this.orderInvoicingModalEnv

          if(this.selectedItemsForInvoice.length == 0){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:'Valitse rivejä laskulle.', snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            return
          }
          if(this.selectedInvoice !== ''){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:'Valitse laskuttamattomat.', snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            return
          }
          
          selectedItemsForInvoice = this.selectedItemsForInvoice
          var selectedItemsObject = {}
          this.getLineItems.forEach(li => {
            if(selectedItemsForInvoice.includes(li.rowId)) selectedItemsObject[li.rowId] = li
          })

          var selectedDateForInvoice = this.selectedDateForInvoice
          var selectedDateForInvoiceEntry = this.selectedDateForInvoiceEntry
          if(this.selectedDateForInvoice && !this.selectedDateForInvoice.seconds) selectedDateForInvoice = firebase.firestore.Timestamp.fromDate(new Date(this.selectedDateForInvoice));
          if(this.selectedDateForInvoiceEntry && !this.selectedDateForInvoiceEntry.seconds) selectedDateForInvoiceEntry = firebase.firestore.Timestamp.fromDate(new Date(this.selectedDateForInvoiceEntry));
          
          var invoiceObject = {
            selectedItemsForInvoice,
            selectedInvoice:this.selectedInvoice,
            selectedItemsObject,
            selectedDateForInvoice:selectedDateForInvoice,
            selectedDateForInvoiceEntry:selectedDateForInvoiceEntry
          }

          var pdIdsByOpIdToUpdate = {}
          var opsToUpdate = []
          this.getLineItems.forEach(li => {
            if(selectedItemsForInvoice.includes(li.rowId) && li.rowId.includes('pd__')) {
              var split = li.rowId.split('__')
              var opId = split[1]
              var pdId = split[2]
              if(!pdIdsByOpIdToUpdate[opId]){
                pdIdsByOpIdToUpdate[opId] = [pdId]
              }
              else pdIdsByOpIdToUpdate[opId].push(pdId)
            }
            else if(selectedItemsForInvoice.includes(li.rowId) && li.rowId.includes('op__') && li.rowId.includes('__product')) {
              opsToUpdate.push(li.opId)
            }

          })
          
          //console.log(invoiceObject)
          if(!isManual){
            await this.syncOrderToNetvisor(this.orderInvoicingModalOrderId,env, 'invoice', invoiceObject)
            console.log("INVOICE CREATED")
          }
          else {
            var oId = this.orderInvoicingModalOrderId
            var o = this.orders[oId]
            var invoices = {}
            if(o.invoices){
              invoices = JSON.parse(JSON.stringify(o.invoices))
            }
            if(!this.manual_invoiceId) {
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:'Lisää laskun id.', snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
              return
            }
            if(!this.manual_invoiceNumber) {
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:'Lisää laskun numero.', snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
              return
            }
            invoices[this.manual_invoiceId] = {
              createdDate:firebase.firestore.Timestamp.fromDate(new Date()),
              dueDate:null,
              invoiceDate:selectedDateForInvoice,
              invoiceDateEntry:selectedDateForInvoiceEntry,
              invoiceNumber:this.manual_invoiceNumber,
              paidDate:null,
              paidSumWithVat:0,
              paidSumWithoutVat:0,
              payments:{},
              selectedItemsForInvoice: this.selectedItemsForInvoice,
              status:"unsent",
              sumWithVat:0,
              sumWithoutVat:this.getTotalOut(),
              vatPercentage:25.5
            }
            this.$store.dispatch('order/set', {
              id:oId,
              invoicesViaSystem:true,
              invoicesAllPaid:false,
              invoices
            })
            console.log(invoices)
            
          }
          

          var userUid = this.user.uid
          Object.keys(pdIdsByOpIdToUpdate).forEach(opId => {
            var pdIds = pdIdsByOpIdToUpdate[opId]
            var op = this.orderedProducts[opId]
            var pd = JSON.parse(JSON.stringify(op.partialDeliveries))
            
            pdIds.forEach(pdId => {
              pd[pdId].invoiceStatus = 'invoiced'
              pd[pdId].invoiceDate = selectedDateForInvoice
              pd[pdId].invoiceUser = userUid
            })

            var totalQuantityForOpViaPds = 0
            Object.keys(pd).forEach(pdId => {
              pd[pdId].deliveredAmount && !isNaN(Number(pd[pdId].deliveredAmount)) ? totalQuantityForOpViaPds += Number(pd[pdId].deliveredAmount) : ''
            })

            //console.log({totalQuantityForOpViaPds})
            if(totalQuantityForOpViaPds >= Number(op.quantity) && !opsToUpdate.includes(opId)) opsToUpdate.push(opId)
            
            this.$store.dispatch('orderedProduct/set', {
              id:opId,
              partialDeliveries:pd,
            })
          })

          opsToUpdate.forEach(async opId => {
            var op = JSON.parse(JSON.stringify(this.orderedProducts[opId]))
            var oldOrderInvoiceStatus = op.orderInvoiceStatus
            console.log({oldOrderInvoiceStatus})
            this.$store.dispatch('orderedProduct/set', {
              id:opId,
              orderInvoiceStatus:'invoiced',
              whenToInvoice: selectedDateForInvoice,
              whenToInvoiceUser: userUid,
            })
            
            var o = this.orders[op.orderId]
            var p = this.products[op.productId]
            var pv = this.productVariations[op.productVariationId]
            var name = p.name.fi + " - " + this.createVariationName(pv)
            var oId = op.orderId
            var copyOfLogs = []
            if(o.activityLog){
              copyOfLogs = JSON.parse(JSON.stringify(o.activityLog))
            }
            await this.timer(1100);
            this.logToOrderHistory(this.user,copyOfLogs,oId,opId,name,'orderInvoiceStatus',oldOrderInvoiceStatus,'invoiced')
          })
          this.selectedItemsForInvoice = []
          this.netvisorSyncActive = false
        }
        catch(e){
          console.log(e)
          this.netvisorSyncActive = false
        }
      },
      customFormatter(date,full) {
        try{
          if(!date) return ''
          if (date.seconds) {
            var myDate = new Date(date.seconds*1000);
            if(full) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
            return dateFormat(myDate, "yyyy-mm-dd")
          }
          else if (date !== undefined && date.seconds === undefined){
            if(full) return dateFormat(date, "yyyy-mm-dd HH:MM")
            return dateFormat(date, "yyyy-mm-dd")
          }
          return ''
        }
        catch(e){
          return ''
        }
      },
      close () {
        this.orderInvoicingModalVisible = false
        setTimeout(() => {
          this.selectedInvoice = ''
          this.selectedItemsForInvoice = []
          this.editedIndex = -1
        }, 300)
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/InvoiceOrderModal.vue